<template>
  <div class="bg-white mb-3">
    <!-- Filters -->
    <Disclosure as="section" aria-labelledby="filter-heading" class="relative z-10 border-t border-b border-gray-200 grid items-center" v-slot="{ open }">
      <h2 id="filter-heading" class="sr-only">Filters</h2>
      <div class="relative col-start-1 row-start-1 py-4">
        <div class="max-w-7xl mx-auto flex space-x-6 divide-x divide-gray-200 text-sm px-4 sm:px-6 lg:px-8">
          <div>
            <DisclosureButton class="group text-gray-700 font-medium flex items-center">
              <FilterIcon class="flex-none w-5 h-5 mr-2 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />
              Filtry: {{ activeFilters }} {{ open ? '(Zwiń)' : '(Rozwiń)'}}
            </DisclosureButton>
          </div>
          <div class="pl-6">
            <button type="button" class="text-gray-500" @click="clearAll">Wyczyść filtry</button>
          </div>
        </div>
      </div>
      <DisclosurePanel class="border-t border-gray-200 py-10">
        <div class="max-w-7xl mx-auto grid grid-cols-2 gap-x-4 px-4 text-sm sm:px-6 md:gap-x-6 lg:px-8">
          <div class="grid grid-cols-1 gap-y-10 auto-rows-min md:grid-cols-2 md:gap-x-6">
            <fieldset>
                <legend class="block text-sm font-medium text-gray-700">Wpisz szukaną frazę</legend>
                <div class="mt-1 relative flex items-center">
                    <input type="text" name="keywords" @keyup.enter="search($event)" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full pr-12 sm:text-sm border-gray-300 rounded-md" />
                    <div class="absolute inset-y-0 right-0 flex py-1.5 pr-1.5">
                        <kbd class="inline-flex items-center border border-gray-200 rounded px-2 text-sm font-sans font-medium text-gray-400"> Enter </kbd>
                    </div>
                </div>
            </fieldset>
            <fieldset>
                <legend class="block text-sm font-medium text-gray-700">Cena</legend>
                <div class="mt-1 flex rounded-md shadow-sm">
                    <span class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm"> od </span>
                    <input type="number" name="priceFrom" class="flex-1 min-w-0 block w-full px-3 py-2 rounded-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-r-0 border-gray-300" placeholder="0.00" v-model="priceFrom" @blur="$emit('changeFilters', 'priceFrom', priceFrom)" />
                    <span class="inline-flex items-center px-3 rounded-none border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm"> do </span>
                    <input type="number" name="priceTo" class="flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300" placeholder="100.00" v-model="priceTo" @blur="$emit('changeFilters', 'priceTo', priceTo)" />
                </div>
                <div class="pt-6 space-y-6 sm:pt-4 sm:space-y-4">
                    <div v-for="(option, optionIdx) in filters.switches" :key="option.value" class="flex items-center text-base sm:text-sm">
                    <input :id="`switch-${optionIdx}`" :name="option.variable" :value="option.value" type="checkbox" class="flex-shrink-0 h-4 w-4 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500" :checked="$route.query[option.variable] === option.value" @change="submitCheckbox($event)" />
                    <label :for="`switch-${optionIdx}`" class="ml-3 min-w-0 flex-1 text-gray-600">
                        {{ option.label }}
                    </label>
                    </div>
                </div>
            </fieldset>
          </div>
          <div class="grid grid-cols-1 gap-y-10 auto-rows-min md:grid-cols-2 md:gap-x-6">
            <fieldset>
				<legend class="block text-sm font-medium text-gray-700">Kategoria</legend>
				<div class="mt-1 space-y-6 sm:space-y-4">
					<select id="location" name="location" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md" @change="changeCategory($event)">
						<option v-for="(option, optionIdx) in filters.categories" :key="option.value" :value="option.value" :selected="$route.query.category === option.value || !option.value && !$route.query.category">
							{{ option.label }}
						</option>
					</select>
				</div>
            </fieldset>
            <fieldset>
              <legend class="block text-sm font-medium text-gray-700">Sklepy</legend>
              <div class="pt-6 space-y-6 sm:pt-4 sm:space-y-4">
                <div v-for="(option, optionIdx) in filters.departments" :key="option.value" class="flex items-center text-base sm:text-sm">
                  <input :id="`department-${optionIdx}`" name="department" :value="option.value" type="radio" class="flex-shrink-0 h-4 w-4 border-gray-300 rounded-full text-indigo-600 focus:ring-indigo-500" :checked="$route.query.department === option.value || !option.value && !$route.query.department" @change="$emit('changeFilters', 'department', option.value)" />
                  <label :for="`department-${optionIdx}`" class="ml-3 min-w-0 flex-1 text-gray-600">
                    {{ option.label }}
                  </label>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </DisclosurePanel>
      <div class="col-start-1 row-start-1 py-4">
        <div class="flex justify-end max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Menu as="div" class="relative inline-block">
            <div class="flex">
              <MenuButton class="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
                Sortowanie
                <ChevronDownIcon class="flex-shrink-0 -mr-1 ml-1 h-5 w-5 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />
              </MenuButton>
            </div>

            <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
              <MenuItems class="origin-top-right absolute right-0 mt-2 w-40 rounded-md shadow-2xl bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div class="py-1">
                  <MenuItem v-for="option in sortOptions" :key="option.name" v-slot="{ active }">
                    <span @click="$emit('changeFilters', 'sort', option.value)" :class="[$route.query.sort === option.value || !$route.query.sort && option.value === 'default' ? 'font-medium text-gray-900' : 'text-gray-500 cursor-pointer', active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm']">
                      {{ option.name }}
                    </span>
                  </MenuItem>
                </div>
              </MenuItems>
            </transition>
          </Menu>
        </div>
      </div>
    </Disclosure>
  </div>
</template>

<script>
import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { ChevronDownIcon, FilterIcon } from '@heroicons/vue/solid'

const filters = {
    switches: [
        { variable: 'type', value: 'promotions', label: 'Wyświetl tylko promocje' },
        { variable: 'showAvailable', value: true, label: 'Wyświetl tylko dostępne' },
        { variable: 'withPhoto', value: true, label: 'Wyświetl tylko ze zdjęciem' },
    ],
    departments: [
        { value: null, label: 'Wszystkie' },
        { value: '1', label: 'Supermarket "u Chowańca"' },
        { value: '2', label: 'Market "u Chowańca"' },
        { value: '3', label: 'Rzeźnik "u Chowańca"' },
        { value: '4', label: 'Domoteo' },
        { value: '5', label: 'Petit' },
    ],
    // categories: [
    //     { value: '', label: 'Wszystkie' },
    //     { value: 'Warzywa i owoce', label: 'Warzywa i Owoce' },
    //     { value: 'Mięso i wędliny', label: 'Mięso i wędliny' },
    //     { value: 'Słodycze i przekąski', label: 'Słodycze i przekąski' },
    // ],
}
const sortOptions = [
  { name: 'Domyślne', value: 'default' },
  { name: 'Cena rosnąco', value: 'priceAscending' },
  { name: 'Cena malejąco', value: 'priceDescending' },
  { name: 'Najnowsze', value: 'newest' },
]

export default {
    components: {
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        ChevronDownIcon,
        FilterIcon,
    },
    data: () => ({
        filters,
        sortOptions,
        priceFrom: null,
        priceTo: null,
    }),
    created() {
        this.getCategories();
        this.priceFrom = this.$route.query.priceFrom ? this.$route.query.priceFrom : null;
        this.priceTo = this.$route.query.priceTo ? this.$route.query.priceTo : null;
    },
    computed: {
        activeFilters() {
            return Object.keys(this.$route.query).length;
        }
    },
    methods: {
        async getCategories() {
            await fetch(`https://cloudpanel.pl/api/uchowanca/categories`)
                .then(response => response.json())
                .then(result => {
                    this.filters.categories = result.categories;
                    console.log(result.categories)
                });
        },
        submitCheckbox(e) {
            if (e.target.checked) {
                console.log('changeFilters', e.target.name, e.target.value);
                this.$emit('changeFilters', e.target.name, e.target.value);
            } else {
                this.$emit('changeFilters', e.target.name, null);
            }
        },
        clearAll() {
            this.priceFrom = null;
            this.priceTo = null;
            this.$emit('clearFilters');
        },
		changeCategory(e) {
			this.$emit('changeFilters', 'category', e.target.value ? e.target.value : null)
		},
		search(e) {
            console.log(e.target.value);
			this.$emit('changeFilters', 'keywords', e.target.value ? e.target.value : null)
		},
    }
}
</script>
